/**
 * Retorna o tipo da chave.
 */
export const getTypeChave = (dsChave: string) => dsChave.slice(0, 2);

/**
 * Retorna o valor inicial de acordo com a chave.
 */
export const getInitialValue = (dsChave: string): boolean | string | number => {
    const typeChave = getTypeChave(dsChave);

    switch (typeChave) {
        case 'fg':
            return false;
        case 'pe':
        case 'vl':
            return 0;
        case 'cd':
        case 'ds':
        default:
            return '';
    }
};

/**
 * Retorna o valor inicial de acordo com a chave para colunas dinâmicas.
 */
export const getInitialValueColunasDinamicas = (dsChave: string) => {
    const typeChave = dsChave;

    switch (typeChave) {
        case 'OPCAO':
            return false;
        case 'NUMERO':
        case 'NUMERO_COM_CARACTERES_ESPECIAIS':
            return 0;

        case 'DATA':
            return String(new Date());

        case 'HORA':
            return '';

        case 'TEXTO':
            return '';
        default:
            return '';
    }
};
